import {
  removeOvertime,
} from '@/routes/AllList/services';
import {
  getDinnerFeeList
} from '../services'
  
export default {
  namespace: 'dinnerFee',
  state: {},
  effects: {
    /**
     * 获取夜餐费列表
     */
    * getDinnerFeeList ({ payload }, { call }) {
      yield new Promise((resolve)=>{
        setTimeout(resolve, 1500)
      })
      return yield call(getDinnerFeeList, payload);
    },
    /**
     * 删除
     */
    * removeDinnerFeeDistribution ({ payload }, { call }) {
      return yield call(removeOvertime, payload);
    },
  },
  reducers: {
    update ( state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
